<script setup>
/* global axios */
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { onBeforeUnmount, ref, watch } from 'vue';

const props = defineProps({
  src: { type: String, default: '' },
  alt: { type: String, default: '' },
  loading: { type: String, default: 'eager' },
  imageClass: { type: String, default: '' },
  placeholderClass: { type: String, default: '' },
});

defineOptions({ inheritAttrs: false });

const objectUrl = ref('');
const state = ref('idle');
let request = null;
let generation = 0;

function release() {
  if (objectUrl.value) URL.revokeObjectURL(objectUrl.value);
  objectUrl.value = '';
}

async function load(value) {
  generation += 1;
  const current = generation;
  request?.abort();
  release();
  if (!value) {
    state.value = 'idle';
    return;
  }
  request = new AbortController();
  state.value = 'loading';
  try {
    const response = await axios({
      url: value,
      method: 'get',
      responseType: 'blob',
      timeout: 20000,
      signal: request.signal,
    });
    if (current !== generation) return;
    objectUrl.value = URL.createObjectURL(response.data);
    state.value = 'ready';
  } catch (error) {
    if (
      current === generation &&
      error?.code !== 'ERR_CANCELED' &&
      error?.name !== 'CanceledError'
    )
      state.value = 'error';
  } finally {
    if (current === generation) request = null;
  }
}

watch(() => props.src, load, { immediate: true });

onBeforeUnmount(() => {
  generation += 1;
  request?.abort();
  release();
});
</script>

<template>
  <div
    v-bind="$attrs"
    data-authenticated-media-image="tg_publication_authenticated_media"
  >
    <img
      v-if="state === 'ready'"
      :src="objectUrl"
      :alt="alt"
      :class="imageClass"
      :loading="loading"
      decoding="async"
    />
    <div v-else-if="state === 'error'" :class="placeholderClass" role="status">
      <span class="i-lucide-image-off size-5" aria-hidden="true" />
      Изображение недоступно
    </div>
    <div v-else :class="placeholderClass" role="status">
      <span
        class="i-lucide-loader-circle size-5 animate-spin"
        aria-hidden="true"
      />
      Загрузка изображения
    </div>
  </div>
</template>
